module.exports = __webpack_public_path__ + "img/nilalogo.0778d813.svg";